import React, { Component } from 'react'
import axios from 'axios'
class SearchUser extends Component{
    constructor(props){
        super(props)
        this.state = {
            hitUsers : []
        }

        this.handleChange = this.handleChange.bind(this)    
    }

    handleChange(e){
        e.preventDefault()
        const { hitUsers } = this.state
        if( hitUsers.length !== 0 ){
            return this.props.addNewUserToTeam(hitUsers[parseInt(e.target.value.split('.')[0],10)-1])
        }
        else if(e.target.value === ""){
            return this.setState({hitUsers:[]})
        }
        let body = {
            keyword:e.target.value
        }
        axios.post('https://us-central1-ling-dev-123.cloudfunctions.net/searchFromElastic',body)
        .then(res=>{
            this.setState({hitUsers:res.data.hits.hits})
        })
    }

    render(){
        const { hitUsers } = this.state
        let datalists = null
        if( hitUsers.length !== 0 ){
            datalists = hitUsers.map((user,index)=>{
                let email = ''
                let phone = ''
                if( user._source.email !== '' ) email = `, Email : ${user._source.email}`
                if( user._source.phone !== '' ) phone = `, Phone : ${user._source.phone}`
                return <option key={index} label={`${user._id} ${email} ${phone}`} value={`${index+1}. ${user._source.name}`}></option>
            })
        }
        return (
            <div>
                <input id="userForAdd" list="searchuser" name="userTextbox" placeholder="name, email, phone" size="60" onChange={this.handleChange}/>
                <datalist id="searchuser" >
                    {datalists}
                </datalist>
            </div>
        )
    }
}

export default SearchUser


// WEBPACK FOOTER //
// ./src/Components/SearchUser.js